export enum ANTRAGSNUMMER_EVENTS {
  ANTRAGSNUMMER_SUCCESSFULL = 'ANTRAGSNUMMER_SUCCESSFULL',
  ANTRAGSNUMMER_FAILED = 'ANTRAGSNUMMER_FAILED',
}
